import * as eHubApi from "./data.service";
import axios from "axios";

function getactivecustomercode() {
  return eHubApi.get(`/api/billing/get-active-customer-code`);
}

function getPackagingMaterialStatusCount() {
  return eHubApi.get("/api/PackagingMaterial/get-status-count");
}

function addNewBillingList(req) {
  console.log("Request Data to API:", req);
  return eHubApi.post(`/api/billing/add-new-billing-configuration`, req, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function editBillingList(req) {
  console.log("Request Data to API:", req);
  return eHubApi.post(`/api/billing/edit-billing-configuration`, req, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function copyCustomerBillingConfiguration(req) {
  console.log("Request Data to API to copy:", req);
  return eHubApi.post(`/api/billing/copy-billing-configuration`, req, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function updateBillingList(req) {
  return eHubApi.post("/api/billing/update-billing-configuration", req);
}

function getcustomerbillingconfiguration(req) {
  return eHubApi.get(`/api/billing/get-customer-billing-configuration?customerCode=${req.customerValue}&category=${req.activeTab}`);
}

function getdefaultbillingconfiguration(req) {
  return eHubApi.get(`/api/billing/get-default-billing-configuration?category=${req.activeTab}&customerCode=${req.customerCode}&billingname=${req.billingname}`);
}

function getbillinglistbycustomer(req) {
  return eHubApi.get(`/api/billing/get-billing-configuration-by-customer?customercode=${req.customerCode}&status=${req.active}`);
}

function getbillingconfigurationbybillingno(req) {
  return eHubApi.get(`/api/billing/get-customer-billing-configuration-by-billingno?billingno=${req.billingNo}&category=${req.activeTab}`);
}

// export function getBillingStatusCount = () => eHubApi.get("/api/billing/get-status-count");
export function getBillingStatusCount(req) {
  return eHubApi.get(`/api/billing/get-status-count?customerCode=${req.customerCode}`);
}
export const deactiveBilling = (req) =>
  eHubApi.del(`/api/billing/deactivate?billingno=${req.billingNo}`);

export const activeBilling = (req) =>
  eHubApi.put(`/api/billing/activate?billingno=${req.billingNo}`);

export const getBillingChargeable = (req) => {
  var category = "";
  if (req.activeTab === "Stuffing & Unstuffing")
    category = "StuffingUnstuffing";
  else if (req.activeTab === "Packaging Material")
    category = "PackagingMaterial";
  else if (req.activeTab === "Management Fees")
    category = "ManagementFees";
  else
    category = req.activeTab;
  return eHubApi.get(`/api/billinginvoice/get-billing-chargeable?invoiceNumber=${req.invoiceNumber}&category=${category}`);
}

export const getBillingInvoice = (req) => {
  return eHubApi.get(`/api/billinginvoice/get-billing-invoice?invoiceNumber=${req.invoiceNumber}`);
}

export const getBillingInvoiceList = (req) => {
  return eHubApi.get(`/api/billinginvoice/get-billing-invoice-list?status=${req.status}&customerCode=${req.customerCode}`);
}

export const editBillingChargeable = (req) => {
  if (req.billCategory === "Stuffing & Unstuffing")
    req.billCategory = "StuffingUnstuffing";
  else if (req.billCategory === "Management Fees")
    req.billCategory = "ManagementFees";
  return eHubApi.put(`/api/billinginvoice/edit-billing-chargeable`, req)
}

export const editBillingInvoiceHeader = (req) => {
  return eHubApi.put(`/api/billinginvoice/edit-billing-invoice-header?invoiceNumber=${req.invoiceNumber}`, req.req)
}

export const getBillingInvoiceStatusCount = (req) => {
  return eHubApi.get(`/api/billinginvoice/get-status-count?customerCode=${req.customerCode}`);
}

export const deactiveBillingInvoice = (req) =>
  eHubApi.del(`/api/billinginvoice/delete?invoiceNumber=${req.invoiceNumber}`);

export const activeBillingInvoice = (req) =>
  eHubApi.put(`/api/billinginvoice/activate?invoiceNumber=${req.invoiceNumber}`);

export const generateBillingInvoice = (req) => {
  return eHubApi.post(`/api/billing/generate-billing-for-storage?`, req)
}

export const getNewConfiguration = (req) => {
  var category = "";
  if (req.activeTab === "Stuffing & Unstuffing")
    category = "STUFFINGUNSTUFFING";
  else if (req.activeTab === "Management Fees")
    category = "MANAGEMENTFEES";
  else
    category = req.activeTab;
  return eHubApi.get(`/api/billinginvoice/get-new-billing-configuration?category=${category}&customerCode=${req.customerCode}`);
}

function getBillingServiceList(req) {
  return eHubApi.get(`/api/billing/get-billing-service-list?customercode=${req.customerCode}&active=${req.active}`);
}

function editBillingService(req) {
  return eHubApi.put(`/api/billing/edit-billing-service?customercode=${req.customerCode}&billServiceId=${req.billServiceId}`, req);
}

function deactivateBillingService(req) {
  return eHubApi.del(`/api/billing/deactivate-billing-service?customercode=${req.customerCode}&billServiceId=${req.billServiceId}`);
}
function activateBillingService(req) {
  return eHubApi.put(`/api/billing/activate-billing-service?customercode=${req.customerCode}&billServiceId=${req.billServiceId}`);
}
function getBillingServiceStatusCount(req) {
  return eHubApi.get(`/api/billing/get-billing-service-status-count?customercode=${req.customerCode}`);
}

function createBillingService(req) {
  return eHubApi.post("/api/billing/create-billing-service", req);
}

function getCustCategorySetting(req) {
  return eHubApi.get(`/api/billing/get-customer-category?customerCode=${req.customerCode}`);
}

function useCustCriteriaOptionsQuery(req) {
  return eHubApi.get(`/api/billing/get-customer-criteria-by-category?customerCode=${req.customerCode}&category=${req.category}`);
}

function getBillingServiceListById(req) {
  return eHubApi.get(`/api/billing/get-billing-service-list-by-id?customercode=${req.customerCode}&billserviceid=${req.billServiceId}`);
}

function getBillingInvoiceCustomerDebtorCode(custcode) {
  return eHubApi.get(`/api/billing/get-billing-customer-debtorcode?customercode=${custcode}`);
}

export const uploadCustomerLogo=(req)=>
  eHubApi.post("/api/billinginvoice/logo/upload",req)

// export const uploadAttachment = ({formData,customerCode}) => {

//   return eHubApi.post(`/api/billinginvoice/upload?customerCode=${customerCode}`, 
//     formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };
export const uploadAttachment = ({ formData, customerCode }) => {
  return eHubApi.post(
    `/api/billinginvoice/upload?customerCode=${customerCode}`,
    formData
  );
};

export const downloadAttachment = (fileName) => {
  return eHubApi.get(
    `/api/billinginvoice/download?fileName=${encodeURIComponent(fileName)}`,
    {
      responseType: "blob", 
    }
  );
};

export { editBillingService,getBillingServiceListById,useCustCriteriaOptionsQuery,getCustCategorySetting,createBillingService,getBillingServiceList,deactivateBillingService,activateBillingService,getBillingServiceStatusCount,getactivecustomercode,addNewBillingList,editBillingList,updateBillingList,getcustomerbillingconfiguration,
  getdefaultbillingconfiguration,
  copyCustomerBillingConfiguration,getbillinglistbycustomer,getbillingconfigurationbybillingno,getBillingInvoiceCustomerDebtorCode};
